import useRequest, { RequestTypes } from './useRequest'
import { currencyFormat } from '../helpers'
import { useEffect } from 'react'

interface IGetUserTariff {
    id: number
    volume?: number
    tsPayed?: number
    dependency?: boolean
    showError?: boolean
    userId?: string
    userRole?: number
}

export const useGetUserTariffRate = ({
    dependency = true,
    id,
    volume,
    tsPayed,
    showError = true,
    userId,
    userRole
}: IGetUserTariff) => {
    const { fetch, result, isLoading } = useRequest({
        link: '/api/billing/v1/tariff-rate-for-user',
        method: RequestTypes.post,
    })

    useEffect(() => {
        if (dependency) {
            fetch({
                showError,
                body: {
                    operation_type_id: id,
                    volume: volume,
                    ts_payed_to: tsPayed,
                    user_id: userId,
                    user_role: userRole
                },
            })
        }
    }, [dependency])

    return {
        isLoading,
        loadingTariffs: dependency && (isLoading || !result),
        balance: `${currencyFormat(result?.available_balance)} ₽`,
        rate: `${currencyFormat(result?.rate)} ₽`,
        rateNumber: Number(result?.rate),
        payTo: result?.ts_pay_account_to,
        balanceNumber: Number(result?.available_balance),
    }
}
